export default __webpack_public_path__ + "static/media/MTNMobileMoney_logo.979b608f.jpg";